export const loaderInitState = {
  isLoading: true,
};
